export const ENVS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  TEST: 'test',
  DEV: 'dev',
  LOCAL: 'local',
} as const;
